import { useEffect, type PropsWithChildren } from 'react'
import { useSetAtom } from 'jotai'

import { suggestedStartTimeShiftAtom } from '../state'
import SuggestedStartTimeSnackbar, {
    type SuggestedStartTimeSnackbarPlacement,
} from './suggested-start-time-snackbar'

export default function SuggestedStartTimeSnackbarScope({
    children,
    placement,
}: PropsWithChildren<{
    placement: SuggestedStartTimeSnackbarPlacement,
}>) {
    const setSuggestedStartTimeShift = useSetAtom(suggestedStartTimeShiftAtom)

    useEffect(() => () => {
        setSuggestedStartTimeShift(null)
    }, [setSuggestedStartTimeShift])

    return (
        <>
            {children}
            <SuggestedStartTimeSnackbar placement={placement} />
        </>
    )
}
